/* eslint-disable @next/next/no-html-link-for-pages */
import React, { useEffect, useState } from "react";
import HeaderTop from "./HeaderTop";
import HeaderBottom from "./HeaderBottom";
import MobileSideBar from "./MobileSideBar.jsx";
import styles from "./NavigationBar.module.scss";
import server from "src/api/server";
import { useNavData } from "src/context/NavContext";

export default function NavigationBar({ HomePage }) {
  const [isMobileSideBarActive, setIsMobileSideBarActive] = useState(false);
  const { navData, servicesData, setServicesData } = useNavData();
  const data = navData;

  useEffect(() => {
    if (servicesData.length > 0) return;
    const fetchServices = async () => {
      try {
        const servicesRes = await server.get("/api/services");
        setServicesData(servicesRes?.data?.data?.services || []);
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  const handleMobileSideBarActivation = () => {
    setIsMobileSideBarActive(!isMobileSideBarActive);
  };

  return (
    <div
      className={
        HomePage ? `${styles.header} ${styles.homePage}` : styles.header
      }
    >
      {/* <HeaderTop data={data} /> */}
      <HeaderBottom
        handleMobileSideBarActivation={handleMobileSideBarActivation}
        data={data}
        servicesData={servicesData}
      />
      <MobileSideBar
        isMobileSideBarActive={isMobileSideBarActive}
        handleMobileSideBarActivation={handleMobileSideBarActivation}
        data={data}
        servicesData={servicesData}
      />
    </div>
  );
}
